import React from 'react';
import styled from 'styled-components';

// Container for the entire table
const TableContainer = styled.div`
  width: 100%;
  margin: 30px auto;
  background-color: ${({ theme }) => (theme === 'dark' ? '#2c3e50' : '#ffffff')};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme === 'dark' ? '0 10px 30px rgba(0, 0, 0, 0.3)' : '0 6px 15px rgba(0, 0, 0, 0.1)'};
  padding: 24px;
  overflow-x: auto;

  @media (max-width: 768px) {
    margin: 20px;
    padding: 16px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const TableCell = styled.td`
  padding: 16px 20px;
  font-size: 1.2rem;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#2c3e50')};
  font-weight: 500;
  text-align: left;
  border-bottom: 1px solid ${({ theme }) => (theme === 'dark' ? '#34495e' : '#f1f1f1')};
  transition: background-color 0.3s ease;
  letter-spacing: 0.5px;

  &:nth-child(odd) {
    font-weight: 600;
  }

  &:hover {
    background-color: ${({ theme }) => (theme === 'dark' ? '#34495e' : '#fafafa')};
    cursor: pointer;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

// Update TableRow to use transient prop $isEven
const TableRow = styled.tr`
  background-color: ${({ theme, $isEven }) =>
    theme === 'dark' ? ($isEven ? '#34495e' : '#2c3e50') : '#ffffff'};

  @media (max-width: 768px) {
    display: block;
    margin-bottom: 10px;
  }
`;

const DoubleColumnTable = ({ data, theme }) => {
  return (
    <TableContainer theme={theme}>
      <Table>
        <tbody>
          {data.map((item, index) => (
            <TableRow key={index} theme={theme} $isEven={index % 2 === 0}>
              {/* Left column for labels */}
              <TableCell theme={theme}>{item.label}</TableCell>

              {/* Right column for values */}
              <TableCell theme={theme}>{item.value}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default DoubleColumnTable;
